// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__MMh_m","header":"PatientBlock_header__NtcdZ","label":"PatientBlock_label__3LXW4","option":"PatientBlock_option__37n4g"};